/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * NO_QUESTIONS — the survey has none yet. QUESTION_NOT_IN_USE — the question has no version in force. TRANSLATION_NOT_APPROVED — the version in force has no approved wording in the language named.
 * @export
 * @enum {string}
 */

export const SurveyGapCodeDto = {
    NoQuestions: 'NO_QUESTIONS',
    QuestionNotInUse: 'QUESTION_NOT_IN_USE',
    TranslationNotApproved: 'TRANSLATION_NOT_APPROVED'
} as const;

export type SurveyGapCodeDto = typeof SurveyGapCodeDto[keyof typeof SurveyGapCodeDto];



